import { Modal, Select, Button } from "antd";
import styled from "styled-components";

export const StyledModal = styled(Modal)`
  .ant-modal-header {
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    background-color: #12619C;
    height: 61px;
  }

  .ant-modal-content {
    border-radius: 10px;
  }

  .ant-modal-body {
    padding-top: 0;
    max-height: calc(90vh - 108px);
    overflow-y: scroll;
  }

  .ant-modal-title {
    color: #fff;
    font-weight: bold;
  }

  .ant-modal-close-x {
    color: #fff;
  }
`;

export const Title = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const Subtitle = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 16px;
  margin-bottom: 10px;
  font-size: 16px;
  font-weight: 500;
  padding-bottom: 8px;
  border-bottom: 1px solid #cecece;
`;

export const StyledSelect = styled(Select) <{ borderColor?: string }>`
  width: 100%;
  
  .ant-select-selector {
    border-radius: 10px !important;
    border-color: ${({ borderColor }) => borderColor} !important;
  }
`;

export const ButtonStyled = styled(Button)`
  border-radius: 8px;
  display: flex;
  align-items: center;
  gap: 8px;
  float: right;
  background-color: #11a557;
  border: none;

  &:hover, &:active, &:focus {
    background-color: #0e8a47;
  }
`;

export const ButtonStyledLink = styled(Button)`
  border-radius: 8px;
  display: flex;
  align-items: center;
  gap: 8px;
  float: right;
  background-color: #f5f5f5;
  color: #666;
  border: 1px solid #ddd;

  &:hover, &:active, &:focus {
    color: #666;
    border: 1px solid #ddd;
    background-color: #e9ecef !important;
  }
`;

export const ContentButton = styled.div`
  display: flex;
  gap: 8px;
  justify-content: flex-end;
`;

export const MatrizLegendItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const MatrizLegendBox = styled.div<{ backgroundColor: string }>`
  min-width: 80px;
  height: 30px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  font-weight: 500;
  color: #fff;
  border: none;
  background: ${(props) => props.backgroundColor};
`;

export const FooterText = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  span {
    display: flex;
    align-items: center;
    gap: 4px;
    font-weight: bold;
    color: #f00;
  }
`;

export const FooterContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
